import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { LanguagesEnum } from "common/enums/languages";
import german from "assets/flags/german.svg";
import english from "assets/flags/english.svg";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Button = styled.button`
  margin-left: 20px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: none;
  cursor: pointer;
`;

const Icon = styled.img`
  width: 100%;
`;

const LanguageSettings = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    switch (i18n.language) {
      case LanguagesEnum.ENGLISH:
        i18n.changeLanguage(LanguagesEnum.GERMAN);
        break;
      case LanguagesEnum.GERMAN:
        i18n.changeLanguage(LanguagesEnum.ENGLISH);
        break;
    }
  };

  return (
    <Wrapper>
      <Button onClick={toggleLanguage}>
        <Icon
          src={i18n.language === LanguagesEnum.ENGLISH ? english : german}
        />
      </Button>
    </Wrapper>
  );
};

export default LanguageSettings;
